import { render, staticRenderFns } from "./AllProfiles.vue?vue&type=template&id=28ed9bde&"
import script from "./AllProfiles.vue?vue&type=script&lang=js&"
export * from "./AllProfiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports